var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',{attrs:{"title":"缺陷统计汇总"}},[_c('custom-table',{attrs:{"columns":_vm.columns,"table-data":_vm.tableData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }